import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b2e4977c")

_pushScopeId("data-v-b2e4977c")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header card-p border-0" }
const _hoisted_5 = { class: "card-title align-items-start flex-column" }
const _hoisted_6 = { class: "card-label fw-bolder fs-3" }
const _hoisted_7 = { class: "card-body p-0" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "subscription-title"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_13 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_14 = {
  key: 1,
  class: "badge badge-light-primary"
}
const _hoisted_15 = {
  key: 2,
  class: "badge badge-light-danger"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("button", {
  class: "action-btn",
  type: "button",
  id: "action-trigger",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" })
], -1)
const _hoisted_17 = {
  class: "dropdown-menu dropdown-menu-end action-dropdown",
  "aria-labelledby": "action-trigger"
}
const _hoisted_18 = { class: "menu-item-wrapper" }
const _hoisted_19 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h3", _hoisted_5, [
            _createVNode("span", _hoisted_6, _toDisplayString(`${_ctx.$t('message.CUSTOMER')} ${_ctx.$t('message.ORDERS')} ${_ctx.$t('message.LIST')}`), 1)
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Table, {
              module: "CustomerDetail",
              loading: _ctx.loader,
              columns: _ctx.columns,
              rows: _ctx.orders,
              padding: 5,
              pagination: _ctx.pagination,
              onHandleCurrentChange: _ctx.handleCurrentChange
            }, {
              "cell-name": _withId(({row:item}) => [
                _createTextVNode(_toDisplayString(item?.customer?.user?.name), 1),
                _hoisted_9,
                (item.order_subscription_history)
                  ? (_openBlock(), _createBlock("span", _hoisted_10, "Subscription order"))
                  : _createCommentVNode("", true)
              ]),
              "cell-status": _withId(({row:item}) => [
                _createTextVNode(_toDisplayString(JSON.parse(item?.order_status?.status)[_ctx.system_locale]?.name) + " " + _toDisplayString(item?.order_status?.id == 4 ? (item?.order_payment != null ? '(Paid)' : '(Failed)') : ''), 1)
              ]),
              "cell-economic": _withId(({row:item}) => [
                (item?.economic_order_id != null)
                  ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(item?.economic_order_number), 1))
                  : (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('message.NOT_SENT')), 1))
              ]),
              "cell-shipment": _withId(({row:item}) => [
                (item?.order_status_id == 6)
                  ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('message.SENT')), 1))
                  : (item?.order_status_id == 10)
                    ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('message.READY_FOR_SHIPMENT')), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('message.NOT_SENT')), 1))
              ]),
              "cell-total": _withId(({row:item}) => [
                _createTextVNode(_toDisplayString(JSON.parse(item.order_totals)?.total?.value), 1)
              ]),
              "cell-actions": _withId(({row:item}) => [
                _hoisted_16,
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    (_ctx.$can('view_order_detail'))
                      ? (_openBlock(), _createBlock("div", _hoisted_19, [
                          _createVNode("a", {
                            onClick: ($event: any) => (_ctx.handleView(item)),
                            class: "menu-link me-1"
                          }, [
                            _hoisted_20,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('message.VIEW')), 1)
                          ], 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["loading", "columns", "rows", "pagination", "onHandleCurrentChange"])
          ])
        ])
      ])
    ])
  ]))
})